import { type AsyncStateObject, type Action } from '../../../interfaces'
import { APP_ACTION_STATUS, COMMON_ACTIONS, FILE_ACTIONS } from '../../../utils/constants'

const INITIAL_STATE: AsyncStateObject<any> = {
  data: '',
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined
}

const saveFileToS3Reducer = (state = INITIAL_STATE, action: Action<any>
): AsyncStateObject<any> => {
  switch (action.type) {
    case FILE_ACTIONS.SAVE_FILE_TO_S3 +
     COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case FILE_ACTIONS.SAVE_FILE_TO_S3 + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case FILE_ACTIONS.SAVE_FILE_TO_S3 + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case FILE_ACTIONS.SAVE_FILE_TO_S3 + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}

export default saveFileToS3Reducer
